import { render, staticRenderFns } from "./EdTableEditor.vue?vue&type=template&id=92840a32&scoped=true&"
import script from "./EdTableEditor.vue?vue&type=script&lang=js&"
export * from "./EdTableEditor.vue?vue&type=script&lang=js&"
import style0 from "./EdTableEditor.vue?vue&type=style&index=0&id=92840a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92840a32",
  null
  
)

export default component.exports